import styled from 'styled-components';

export const Wrapper = styled.div`
  text-align: center;
  padding-top: 20px;
  padding-bottom: 100px;
  width: 100%;
  max-width: 66%;
  @media (max-width: 767px) {
    max-width: 100%;
    padding-inline: 16px;
  }
  .icon {
    width: 60px;
    margin: 0 auto 30px;
  }
  .heading {
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: var(--color-link);
    margin: 0 0 16px;
  }
  .message {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: var(--color-text-muted);
    margin: 0 0 12px;
  }
`;
